import { createClient } from '@supabase/supabase-js'
import { env } from './env'

// Passthrough do auth lock em DEV e PROD.
// Motivo: navigator.locks serializa refresh de token entre abas, mas se uma aba
// travar/crashar segurando o lock, abas seguintes ficam em getSession() pendente
// para sempre (causa do "carregando eterno, recarregar resolve"). Como o portal
// roda uma sessão por aba sem multi-write concorrente, o lock nativo só introduz
// risco de deadlock sem benefício real.
const noopAuthLock = { lock: (_name, _acquireTimeout, fn) => fn() }

export const supabase = createClient(env.SUPABASE_URL, env.SUPABASE_ANON_KEY, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    ...noopAuthLock,
  },
})

/**
 * Acesso a schemas específicos. SEMPRE prefira o SDK em `@infosaas/shared`.
 * Use estes accessors só em pontos que ainda não foram migrados pro SDK.
 */
export const db = {
  get portal() {
    return supabase.schema('portal')
  },
  get operacoes() {
    return supabase.schema('operacoes')
  },
  get shared() {
    return supabase.schema('shared')
  },
}
